import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
const ArendeStatusOptions =[
    {Value:1,label:<IntlMessages id="Order.status.processed"/>},
    {Value:5,label:<IntlMessages id="Order.status.Done"/>}
]
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
export default function OrderStatus(props) {
    const classes = useStyles();
    const [currency, setCurrency] = React.useState(0);
    const OrderStatusList = useSelector(state=>state.accountsData.OrderStatusList)
    const handleChange = (event) => {
        setCurrency(event.target.value);
        props.onChangeHandle("OrderStatus",event.target.value)
    };
    React.useEffect(()=>{
        setCurrency(0)  
    },[OrderStatusList])
    console.log(OrderStatusList,"EEE2")
    return (
        <form className={classes.root}>
            <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                    select
                    label={<IntlMessages id="appKontoModule.status"/>}
                    variant="outlined"
                    size="small"
                    value={currency}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option key={0} value={0}><IntlMessages id="Choose"/></option>
                    {
                    isEmpty(OrderStatusList)?
                    ArendeStatusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    )):
                    OrderStatusList.map(item=>{
                        return  <option key={item.Value} value={item.Value}>
                        {item.Meta}
                    </option>
                    })
                    }
                </TextField>
            </div>
        </form>
    );
}

/*

class AvtalsTyp extends Component {
    state={
        ArendeStatus:0
    }
    getAvtalType=(e)=>{
        let Meta = "OrderStatus"
        this.props.onChangeHandle(Meta,e.target.value)        
    }

    render() {
        const OrderStatusList = useSelector(state=>state.accountsData.OrderStatusList)

        return (
            <div>
                <form>
                <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                    select
                    label={<IntlMessages id="Input.Status"/>}
                    variant="outlined"
                    size="small"
                    value={this.state.ArendeStatus}
                    fullWidth
                    onChange={this.getAvtalType}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                    {ArendeStatusOptions.map((option) => (
                        <option key={option.Value} value={option.Value}>
                            {option.Label}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
            </div>
        );
    }
}

export default (AvtalsTyp);
*/